

import { UseFormReturn } from 'react-hook-form';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { SESSION_TYPES } from '../../../constants';
import { TrainingFormValues } from '../../../types';

interface SessionTypeSectionProps {
  form: UseFormReturn<TrainingFormValues>;
}

export function SessionTypeSection({
  form
}: SessionTypeSectionProps) {
  return (
    <FormField 
      control={form.control} 
      name="sessionType" 
      render={({ field }) => (
        <FormItem>
          <FormLabel>Session Type</FormLabel>
          <FormControl>
            <Select 
              value={String(field.value || SESSION_TYPES[0])} 
              onValueChange={field.onChange}
            >
              <SelectTrigger>
                <SelectValue placeholder="Select a session type" />
              </SelectTrigger>
              <SelectContent>
                {SESSION_TYPES.map(type => (
                  <SelectItem key={type} value={type}>
                    {type}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </FormControl>
          <FormMessage />
        </FormItem>
      )} 
    />
  );
}
